import Cookies from 'js-cookie'
import getConfig from 'next/config'

export const EVENT_TRACKING_STORAGE_KEY = 'ts_track'
export const PAGE_TRACKING_STORAGE_KEY = 'ts_page'
export const PAGE_SOURCE_TRACKING_STORAGE_KEY = 'ts_page_source'
export const identifier = { project: 'sirius' }
export function trackingAllowed(req = null) {
  const { CONSENT_COOKIE_NAME, CONSENT_COOKIE_ANALYTICAL } = getConfig().publicRuntimeConfig

  const consentValue = req ? req.cookies[CONSENT_COOKIE_NAME] : Cookies.get(CONSENT_COOKIE_NAME)

  if (!consentValue) return false

  // Users who previously has opt-out of cookies
  if (consentValue === 'false') return false

  return consentValue.includes(CONSENT_COOKIE_ANALYTICAL)
}
export function analyticsAvailable() {
  return Boolean(global && global.analytics && typeof global.analytics.track === 'function')
}
export { track } from './track'
export { page, pageSource } from './page'
export { processTrackingStorage } from './storage'
export { setTrackingIdentity } from './setTrackingIdentity'
export { resetTrackingIdentity } from './resetTrackingIdentity'
export { trackExperiments } from './trackExperiments'
